"use client";

import { useEffect, useState } from "react";
import { Modal, TextInput, Button, Group } from "@mantine/core";

const MAX_NAME_LENGTH = 30;

interface Props {
  opened: boolean;
  onClose: () => void;
  onConfirm: (newName: string) => void;
}

// Confirming with an empty box is a no-op (current name is left untouched),
// same as closing the modal any other way — only a non-empty value renames.
export function RenameFilterModal({ opened, onClose, onConfirm }: Props) {
  const [name, setName] = useState("");

  useEffect(() => {
    if (opened) setName("");
  }, [opened]);

  const handleConfirm = () => {
    const trimmed = name.trim();
    if (trimmed) {
      onConfirm(trimmed);
    }
    onClose();
  };

  return (
    <Modal opened={opened} onClose={onClose} title="Rename filter" size="sm" centered>
      <TextInput
        placeholder="What would you like to rename this filter to?"
        value={name}
        onChange={(e) => setName(e.currentTarget.value)}
        maxLength={MAX_NAME_LENGTH}
        onKeyDown={(e) => {
          if (e.key === "Enter") handleConfirm();
        }}
        data-autofocus
      />
      <Group justify="flex-end" mt="md" gap="sm">
        <Button variant="default" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={handleConfirm}>Confirm</Button>
      </Group>
    </Modal>
  );
}

export default RenameFilterModal;
